// Mock data pour Le Paradis – Bondy (données non utilisées par les images)
// Les images sont maintenant gérées localement dans /public/media/photos/

export const restaurantInfo = {
  name: "Le Paradis – Bondy",
  tagline: "Pizzeria Artisanale",
  description: "Découvrez les saveurs authentiques de notre pizzeria artisanale. Depuis 2010, nous préparons avec passion des pizzas traditionnelles, des burgers gourmands et des plats méditerranéens dans une ambiance chaleureuse.",
  address: "43 Av. du Maréchal de Lattre de Tassigny, 93140 Bondy, France",
  phone: "01 41 55 25 85",
  hours: "Ouvert tous les jours • Ferme à 23:30",
  priceRange: "1–10 € par personne",
  rating: 4.8,
  reviewCount: 24
};

export const faqItems = [
  {
    question: "Proposez-vous la livraison ?",
    answer: "Oui, nous livrons via Uber Eats. Vous pouvez commander directement depuis leur application ou notre site."
  },
  {
    question: "Peut-on réserver une table ?",
    answer: "Absolument ! Vous pouvez réserver par téléphone au 01 41 55 25 85 ou directement sur place. Nous recommandons de réserver pour les groupes de plus de 4 personnes."
  },
  {
    question: "Avez-vous des options végétariennes ?",
    answer: "Oui, nous proposons plusieurs pizzas végétariennes. N'hésitez pas à demander conseil à notre équipe."
  },
  {
    question: "Quels sont les moyens de paiement acceptés ?",
    answer: "Nous acceptons les espèces, cartes bancaires, et tickets restaurant."
  }
];
